var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initPath = '/[ssgParams]';
var getPathName = function (pathname) {
    var _a;
    if (pathname === initPath)
        return '/';
    if (pathname.includes(initPath))
        return (_a = "".concat(pathname).split(initPath)) === null || _a === void 0 ? void 0 : _a[1];
    return pathname;
};
var getQuery = function (query) {
    var params = __assign({}, query);
    if (params === null || params === void 0 ? void 0 : params.ssgParams)
        delete params.ssgParams;
    return params;
};
var updateQueryParam = function (router, paramName, paramValue) {
    var _a;
    var query = getQuery(router.query);
    var newQuery = __assign(__assign({}, query), (_a = {}, _a[paramName] = paramValue, _a));
    router.push({ pathname: getPathName(router.pathname), query: newQuery });
};
var setQuery = function (_a) {
    var _b, _c;
    var router = _a.router, val = _a.val, queryName = _a.queryName, deleteQuery = _a.deleteQuery;
    var params = getQuery(router.query);
    var page = {};
    if ((_b = router.query) === null || _b === void 0 ? void 0 : _b.page) {
        page = { page: (_c = router.query) === null || _c === void 0 ? void 0 : _c.page };
    }
    var query = deleteQuery
        ? __assign(__assign({}, Object.entries(params)
            .filter(function (_a) {
            var key = _a[0];
            return key !== deleteQuery;
        })
            .reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
        }, {})), page) : __assign(__assign({}, params), page);
    if (val)
        query[queryName] = val;
    router.push({
        pathname: getPathName(router.pathname),
        query: val
            ? query
            : Object.entries(query)
                .filter(function (_a) {
                var key = _a[0];
                return key !== queryName;
            })
                .reduce(function (acc, _a) {
                var _b;
                var key = _a[0], value = _a[1];
                return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
            }, {}),
    });
};
var deleteQuery = function (router, urlQuery) {
    var params = getQuery(router.query);
    return router.replace({
        pathname: getPathName(router.pathname),
        query: Object.entries(params)
            .filter(function (_a) {
            var key = _a[0];
            return key !== urlQuery;
        })
            .reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
        }, {}),
    }, undefined, {
        scroll: false,
    });
};
var deleteManyQuery = function (router, queries) {
    var params = getQuery(router.query);
    return router.replace({
        pathname: getPathName(router.pathname),
        query: Object.entries(params)
            .filter(function (_a) {
            var key = _a[0];
            return !queries.includes(key);
        })
            .reduce(function (acc, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)));
        }, {}),
    }, undefined, {
        scroll: false,
    });
};
var routerPush = function (router, href, as, options) {
    return router.push(href, as, options);
};
var routerReplace = function (router, href) { return router.replace(href); };
var routerReload = function (router) { return router.reload(); };
export { deleteQuery, deleteManyQuery, setQuery, getPathName, getQuery, updateQueryParam, routerPush, routerReplace, routerReload, };
//# sourceMappingURL=urlControl.js.map